export const getSearchFiltersForPdp = (query) => {
  const {
    size_converted: sizeConverted,
    instant_ship_lowest_price_cents: instantShipLowestPriceCents,
    product_condition: productCondition,
  } = query;

  // have to set to empty array if it doesnt exist
  const shoeConditions = productCondition || [];
  const sizes = sizeConverted || [];

  return {
    shoeConditions: Array.isArray(shoeConditions) ? shoeConditions : [shoeConditions],
    sizes: Array.isArray(sizes) ? sizes : [sizes],
    instantShip: Boolean(instantShipLowestPriceCents),
  };
};
